import React, { useMemo } from 'react';
import { MultiSelect } from 'react-multi-select-component';
import './MultiSelectField.scss';

const MultiSelectField = ({
  options = [],
  optionValues,
  items,
  value = [],
  onChange,
  hasSelectAll = true,
  className = 'midFont',
  disabled = false,
  labelledBy = '',
  overrideStrings,
  valueRenderer
}) => {
  const multiOptions = useMemo(() => {
    if (items?.length) return items;
    return options.map((label, index) => ({
      label,
      value: optionValues ? optionValues[index] : label
    }));
  }, [items, options, optionValues]);

  const selected = useMemo(
    () => multiOptions.filter(option => value.includes(option.value)),
    [multiOptions, value]
  );

  const handleChange = selectedOptions => {
    onChange(selectedOptions.map(option => option.value));
  };

  const renderValue =
    valueRenderer ||
    (selected => (selected.length ? selected.map(item => item.label).join(', ') : ''));

  return (
    <div className="multi-select-field">
      <MultiSelect
        options={multiOptions}
        value={selected}
        onChange={handleChange}
        labelledBy={labelledBy}
        hasSelectAll={hasSelectAll}
        disableSearch
        showCheckbox
        closeOnChangedValue={false}
        className={className}
        disabled={disabled}
        valueRenderer={renderValue}
        overrideStrings={{
          selectAll: 'All',
          allItemsAreSelected: 'All',
          selectSomeItems: 'Select...',
          ...overrideStrings
        }}
      />
    </div>
  );
};

export default MultiSelectField;
